import * as React from 'react'

import { cn } from '@/registry/reapit/lib/utils'

// ---------------------------------------------------------------------------
// Label — native <label> replacement for @radix-ui/react-label
// ---------------------------------------------------------------------------
// Radix Label was a thin wrapper around <label> with pointer-event handling.
// A native <label> element provides all required accessibility semantics.
// ---------------------------------------------------------------------------

// DS Label spec:
//   Typography: DS S Medium — text-sm (14px) font-medium, colour: foreground (neutral-900)
//   Required indicator: the label itself does not render the asterisk;
//   consuming code should append a required marker via aria-required / required prop on the input.
//   The Field component handles the required asterisk pattern via FieldLabel.
function Label({ className, ...props }: React.ComponentProps<'label'>) {
  return (
    <label
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm leading-none font-medium text-foreground select-none',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  )
}

export { Label }
